import { client } from '../../apiClient';
import {
  AdminPermissions,
  SuperadminWithPermissions,
} from '../../../models/admin/permissions/AdminPermission';

export const getSuperadmins = async (): Promise<SuperadminWithPermissions[]> => {
  return client(true, true)
    .get<SuperadminWithPermissions[]>('/admin/permissions')
    .then((response) => response.data);
};

export const updateSuperadminPermissions = async (
  userId: number,
  permissions: AdminPermissions
): Promise<void> => {
  return client(true, true)
    .put(`/admin/permissions/${userId}`, permissions)
    .then((response) => response.data);
};
